import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-server-down',
  templateUrl: './server-down.component.html',
  styleUrls: ['./server-down.component.scss']
})

export class ServerDownComponent {
  constructor(private router: Router) {}

  retryLogin() {
    this.router.navigate(['/signin']);
  }
}
